<div class="h-100 mh3 flex flex-column justify-center items-center">
    <p class="f3 b mb3">{{ titleLabel }}</p>
    <p>{{ contactText }}</p>
    <ul class="lh-copy">
        <li>email: <a href="mailto:hello@f3igao.com" class="ruby no-underline underline-hover pointer" (click)="sendClickEvent('email')">hello@f3igao.com</a></li>
        <li>linkedin: <a href="https://www.linkedin.com//in/f3igao" target="_blank" class="ruby no-underline underline-hover pointer" (click)="sendClickEvent('linkedin')">linkedin.com/in/f3igao</a></li>
    </ul>
</div>